import { render, staticRenderFns } from "./PatientCard.vue?vue&type=template&id=43f72aac&scoped=true"
import script from "./PatientCard.vue?vue&type=script&lang=js"
export * from "./PatientCard.vue?vue&type=script&lang=js"
import style0 from "./PatientCard.vue?vue&type=style&index=0&id=43f72aac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f72aac",
  null
  
)

export default component.exports